import AkteCardEasyMode from './component'
export { AkteCardEasyMode }
export default AkteCardEasyMode